module.exports = __webpack_public_path__ + "static/media/fruit-pealing-small.15239d69.jpg";